<template>
  <div class="flex flex-col justify-between">
    <header class="mint-header sticky top-0 justify-between">
      <router-link to="/prices">
        <div v-if="accountIsFree" class="flex items-center">
          <span>Upgrade</span>
          <i class="material-icons">upgrade</i>
        </div>
        <div v-else>Carpe Diem {{ account }}</div>
      </router-link>
      <div class="flex items-center cursor-pointer" @click="logout">
        <span>Logout</span>
        <i class="material-icons ml-1 font-18px">logout</i>
      </div>
    </header>

    <div
      class="settings-content text-xs pt-5 px-10px flex flex-col justify-between items-center"
    >
      <div class="self-start">
        <p>
          Crafted with ♥ in the EU by
          <a
            href="https://james.vodang.com"
            target="_blank"
            class="text-primary"
            >James Vodang</a
          >
        </p>
        <p class="mt-4">
          My hope with this app is to give users clarity over their habits, and
          in turn, empower them to grow 🚀
        </p>
        <p class="mt-4">
          <span class="font-semibold">Want to be productive at your desk?</span
          ><br />
          Meet the original printable
          <a
            href="https://carpe-diem-calendar.vodang.com"
            target="_blank"
            class="text-primary"
            >Carpe Diem Calendar</a
          >
          👀
        </p>
      </div>

      <div class="self-center text-center italic">
        <p>Developed for my better half<br />May she fulfil her potential</p>
        <p class="mt-4">
          Dedicated to my second father (1956–2020)<br />May he rest in paradise
        </p>
      </div>

      <div class="h-62px"></div>
    </div>
  </div>
</template>

<script>
import userModule from '@/store/modules/user.module'

export default {
  name: 'About',

  computed: {
    user: userModule.user,
    accountIsFree: userModule.accountIsFree,
    accountIsPro: userModule.accountIsPro,
    accountIsLife: userModule.accountIsLife,

    account() {
      return this.user.account
    }
  },

  methods: {
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>
<style lang="scss" scoped>
.mint-header {
  display: flex;
  align-items: center;
  height: 62px;
  .a-icon {
    outline: none;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 18px;
    }
  }
}
.settings-content {
  height: calc(100vh - 62px);
}
.px-10px {
  padding-left: 10px;
  padding-right: 10px;
}
.font-18px {
  font-size: 18px;
}
.h-62px {
  height: 62px;
}
</style>
